export default {
  FINAL_INVESTMENT_DATE_CALCULATOR_REPOSITORY: Symbol.for('FINAL_INVESTMENT_DATE_CALCULATOR_REPOSITORY'),
  GET_FINAL_INVESTMENT_DATE_CALCULATOR_QUERY: Symbol.for('GET_FINAL_INVESTMENT_DATE_CALCULATOR_QUERY'),
};
